/*
 * @Author: your name
 * @Date: 2020-03-19 10:54:01
 * @LastEditTime: 2020-07-23 17:51:24
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \kxzxweb\src\pages\article\index.js
 */

import React from 'react'
import { Ldetail } from './style'
import { Empty, Skeleton } from 'antd'
import ShareBox from '../shareBox/index'
import { withRouter } from 'react-router-dom'
import ArticleSection from 'common/navSection/article'
import ArticleSectionNew from 'common/navSection/aeticleNew'
import { connect } from 'react-redux'
import qs from 'query-string'

const _article = '<p style="text-align: center; text-indent: 0em;">北京科学中心</p><p style="text-align: center; text-indent: 0em;" class="11">给大家拜年啦！</p><p style="text-align: center; text-indent: 0em;">在这辞旧迎新的日子里，</p><p style="text-align: center; text-indent: 0em;">北京科学中心主任何素兴</p><p style="text-align: center; text-indent: 0em;">携北京科学中心工作人员向大家拜年啦！</p><p style="text-align: center; text-indent: 0em;"><video class="edui-upload-video  vjs-default-skin        video-js" controls="" poster="http://scimall.org/images/poster_1.png" preload="none" width="770" height="539" src={`${process.env.REACT_APP_IMGBASE}/administrator/data/ueditor/20210208/6021449b5de8f.mp4" data-setup="{}"><source src={`${process.env.REACT_APP_IMGBASE}/administrator/data/ueditor/20210208/6021449b5de8f.mp4" type="video/mp4"></video></p><p style="text-indent: 2em; text-align: center;">北京科学中心主任何素兴寄语</p><p style="text-indent: 0em; text-align: center;"><video class="edui-upload-video  vjs-default-skin    video-js"  poster="http://scimall.org/images/poster_2.png" controls="" preload="none" width="771" height="530" src={`${process.env.REACT_APP_IMGBASE}/administrator/data/ueditor/20210208/6020fa2d80a55.mp4" data-setup="{}"><source src={`${process.env.REACT_APP_IMGBASE}/administrator/data/ueditor/20210208/6020fa2d80a55.mp4" type="video/mp4"></video></p><p style="text-indent: 2em; text-align: center;"><span style="text-align: center; text-indent: 32px;">北京科学中心工作人员寄语</span></p><p style="text-align: center; text-indent: 0em;"><img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/ueditor/20210208/6020f9f3a03c5.jpg" title="111111.webp.jpg" alt="111111.webp.jpg" width="840" height="630" border="0" vspace="0" style="width: 840px; height: 630px;"></p><p style="text-indent: 2em; text-align: center;"><span style="font-size: 14px;">苗晓霞/摄</span></p><p style="text-align: center; text-indent: 0em;">伴随着新年钟声的敲响，</p><p style="text-align: center; text-indent: 0em;"><span style="text-indent: 0em;">牛年来啦!</span></p><p style="text-align: center; text-indent: 0em;">回望2020年，</p><p style="text-align: center; text-indent: 0em;">我们经历了太多，</p><p style="text-align: center; text-indent: 0em;">相信在新的一年里，</p><p style="text-align: center; text-indent: 0em;">一定扭转乾坤！！</p><p style="text-align: center; text-indent: 0em;">值此新年之际，</p><p style="text-align: center; text-indent: 0em;">感谢每一位认可、</p><p style="text-align: center; text-indent: 0em;">支持北京科学中心的观众！</p><p style="text-align: center; text-indent: 0em;">2021年，北京科学中心将为大家带来</p><p style="text-align: center; text-indent: 0em;">更优质的服务和更精彩的科普内容。</p><p style="text-align: center; text-indent: 0em;">同时，衷心祝愿大家新年快乐，</p><p style="text-align: center; text-indent: 0em;">阖家安康！</p><p style="text-indent: 0em; text-align: center;"><span style="text-indent: 0em;">牛年大吉！</span></p><p style="text-align: center; text-indent: 0em;">牛气冲天!</p><p><br></p></p>'

class Article extends React.Component {
  render() {
    
    return (
      <Ldetail>
        {this.state.detailLoading?<Skeleton active />:
        (this.state.article.post_title ? (
          this.state.article.post_status == '2' ? (
            <Empty className='empty'/>
          ) : (
          <div>
            
            {this.fromUrl()?<ArticleSectionNew yc={this.fromUrl()}></ArticleSectionNew>:<ArticleSection articleLink={this.state.catName} />}
            <h2>{this.state.article.post_title}</h2>
            <p className="l_d_time" style={{display:'flex',justifyContent:'center'}}>
              {this.state.article.post_date}<br/>
              {
                this.state.article.post_source?(
                    <span className="l_d_time">来源：{this.state.article.post_source}</span>
                ):null
              }
              <ShareBox />
            </p>
             
            {
              this.state.article.post_content &&
              <>
                {
                  parseInt(this.props.match.params.id) === 3230 ?
                    <p
                      dangerouslySetInnerHTML={{
                        __html: _article,
                      }}
                      className="l_d_content"
                    ></p>
                    : <p
                      dangerouslySetInnerHTML={{
                        __html: this.state.article.post_content,
                      }}
                      className="l_d_content"
                    ></p>
                }
              </>
            }
            <div onClick={() => this.goBack()} className="goBack">
              返回
            </div>
          </div>
          )
        ) : (
          <Empty className='empty'/>
          )
        )
      }
      </Ldetail>
    )
  }
  constructor(props) {
    super(props)
    this.state = {
      article: {},
      catName: [],
      historyPath: '',
      detailLoading: true
    }
  }
  fromUrl=()=>{
    const { search } = this.props.location
    const { yc } = qs.parse(search)
    console.log('======================')
    console.log(yc)
    return yc
  }
  goBack() {
    // if(this.props.history.length > 1){
    //     this.props.history.goBack()
    // }else{
    //     window.location.href = "/";
    // }
    const articlePage= localStorage.getItem('article_'+this.props.match.params.id)
    const tzggPage= localStorage.getItem('article_tzgg_'+this.props.match.params.id)

    if(articlePage){
      localStorage.setItem('NOW_PAGE',articlePage)
    }else if(tzggPage){
      const labelId= localStorage.getItem('article_labelId_'+this.props.match.params.id)
      const labelIndex= localStorage.getItem('article_labelIndex_'+this.props.match.params.id)
      localStorage.setItem('NOW_TZGG_PAGE',tzggPage)
      localStorage.setItem('NOW_LABEL_ID',labelId)
      localStorage.setItem('NOW_LABEL_INDEX',labelIndex)
    }
    this.props.history.push(this.state.historyPath)
  }
  componentWillUnmount(){
    localStorage.removeItem('article_'+this.props.match.params.id)
    localStorage.removeItem('article_tzgg_'+this.props.match.params.id)
    localStorage.removeItem('article_labelId_'+this.props.match.params.id)
    localStorage.removeItem('article_labelIndex_'+this.props.match.params.id)
    document.title="北京科学中心"
    shareFun()
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      historyPath: this.props.historyPath,
      detailLoading: true,
    })
    this.goTo()
    if (nextProps.match.params.id) {
      React.$request({
        url:'Portal/Index/post_detail',
        method:'get',
        params: {
          id: nextProps.match.params.id
        }
      }).then(res=>{
        document.title = res.data.post_title
        shareFun()
        this.setState({
          article: res.data,
          catName: res.cat_name,
          detailLoading: false
        })
      })
      React.$request({
        url:'Portal/Index/storeArticleClicks',
        method:'get',
        params: {
          id: nextProps.match.params.id
        }
      }).then(res=>{
        console.log(res)
      })
    }
  }

  goTo() {
    let scrollToTop = window.setInterval(function () {
      let pos = window.pageYOffset
      if (pos > 0) {
        window.scrollTo(0, pos - 10000) // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop)
      }
    }, 2)
  }

}
const mapStateToProps = (state) => {
  return {
    historyPath: state.getIn(['history', 'historyPath']),
  }
}

export default withRouter(connect(mapStateToProps)(Article))
